import { render, staticRenderFns } from "./NewsletterList.vue?vue&type=template&id=4149b1d4"
import script from "./NewsletterList.vue?vue&type=script&lang=js"
export * from "./NewsletterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports